<template>
  <d2-container class="page">
    <d2-container type="full">
      <div slot="header">
        <el-row :gutter="12">
          <el-col :span="6">
            <el-card shadow="hover"
                     class="header_card_index">
              <div class="header_left_index">
                <img src="../../assets/icon/Windows.png"
                     class="header_img">
              </div>
              <div class="header_right_index">
                <span>本周售出</span>
                <div class="bottom clearfix">
                  <span class="content">{{tombSoldOfWeek}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <div class="header_left_index">
                <img src="../../assets/icon/Android.png"
                     class="header_img">
              </div>
              <div class="header_right_index">
                <span>本月营业额</span>
                <div class="bottom clearfix">
                  <span class="content">{{homeMonthSaleMoney}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <div class="header_left_index">
                <img src="../../assets/icon/iOS.png"
                     class="header_img">
              </div>
              <div class="header_right_index">
                <span>墓穴已售</span>
                <div class="bottom clearfix">
                  <span class="content">{{tombsSold}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <div class="header_left_index">
                <img src="../../assets/icon/React.png"
                     class="header_img">
              </div>
              <div class="header_right_index">
                <span>墓穴空闲</span>
                <div class="bottom clearfix">
                  <span class="content">{{tombFree}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="inner">
        <div class="charts_left">
          <ve-pie :data="stateData"
                  :settings="stateSettings"
                  v-bind="pubSetting"></ve-pie>
        </div>
        <div class="charts_right">
          <ve-line :data="salesMoneyData"
                   :extend="extend"
                   :settings="salesSettings"
                   v-bind="pubSetting"></ve-line>
        </div>
        <!-- <div style="width:33%;height:95%; float: left;">
          <ve-line :data="salesCountData" :extend="extend" v-bind="pubSetting"></ve-line>
        </div>-->
      </div>
    </d2-container>
  </d2-container>
</template>

<script>
import list from "@/pages/demo/charts/list/_mixin/list.js";
import D2HelpBtn from "./components/d2-help-btn";
import D2Badge from "./components/d2-badge";
import { mapActions } from 'vuex'
export default {
  components: {
    D2HelpBtn,
    D2Badge
  },
  mixins: [list],
  data () {
    this.extend = {
      "xAxis.0.axisLabel.rotate": 45
    };
    this.stateSettings = {
      dimension: "type",
      metrics: "count",
      radius: 200,
      offsetY: 300
    };
    this.salesSettings = {
      axisSite: { right: ["销售数量"] },
      yAxisType: ["normal", "normal"],
      yAxisName: ["元", "座"]
    };
    return {
      stateData: {
        columns: ["type", "count"],
        rows: [
          { type: "空闲", count: 1393 },
          { type: "全款", count: 3530 },
          { type: "定金", count: 2923 },
          { type: "约金", count: 1723 },
          { type: "回购", count: 2000 }
        ]
      },
      salesMoneyData: {
        columns: ["日期", "销售额", "销售数量"],
        rows: [
          { 日期: "1月", 销售额: 139300, 销售数量: 12 },
          { 日期: "2月", 销售额: 353000, 销售数量: 32 },
          { 日期: "3月", 销售额: 292300, 销售数量: 26 },
          { 日期: "4月", 销售额: 172300, 销售数量: 14 },
          { 日期: "5月", 销售额: 379200, 销售数量: 34 },
          { 日期: "6月", 销售额: 459300, 销售数量: 42 },
          { 日期: "7月", 销售额: 139300, 销售数量: 10 },
          { 日期: "8月", 销售额: 353000, 销售数量: 32 },
          { 日期: "9月", 销售额: 292300, 销售数量: 26 },
          { 日期: "10月", 销售额: 172300, 销售数量: 14 },
          { 日期: "11月", 销售额: 379200, 销售数量: 34 },
          { 日期: "12月", 销售额: 459300, 销售数量: 42 }
        ]
      },
      salesCountData: {
        columns: ["日期", "销售数量"],
        rows: [
          { 日期: "1月", 销售数量: 13 },
          { 日期: "2月", 销售数量: 35 },
          { 日期: "3月", 销售数量: 29 },
          { 日期: "4月", 销售数量: 17 },
          { 日期: "5月", 销售数量: 37 },
          { 日期: "6月", 销售数量: 45 },
          { 日期: "7月", 销售数量: 13 },
          { 日期: "8月", 销售数量: 35 },
          { 日期: "9月", 销售数量: 29 },
          { 日期: "10月", 销售数量: 17 },
          { 日期: "11月", 销售数量: 37 },
          { 日期: "12月", 销售数量: 45 }
        ]
      },
      tombsSold: 0,//墓穴已售
      tombFree: 0,//墓穴空闲
      tombSoldOfWeek: 0,//本周售出
      homeMonthSaleMoney: 0// 本月销售额
    };
  },
  methods: {
    ...mapActions('d2admin/tomb', [
      'getHomeTombCount'

    ]),
    ...mapActions("d2admin/salesRecord", [
      'countHomeWeekSoldTomb',
      'countHomeMonthSaleMoney',
      'countHomeLineChart'
    ])
  },
  mounted () {
    this.getHomeTombCount({
      vm: this
    })
    this.countHomeWeekSoldTomb({
      vm: this
    })
    this.countHomeMonthSaleMoney({
      vm: this
    })
    this.countHomeLineChart({
      vm: this
    })
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/style/public.scss';
.content {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.inner {
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: 20px;
  left: 20px;
}

.charts_left {
  min-width: 480px;
  width: 40%;
  min-height: 600px;
  height: 95%;
  float: left;
}

.charts_right {
  width: 60%;
  min-height: 600px;
  height: 95%;
  float: left;
}
.header_card_index {
  height: 91px;
  font-size: 18px;
}

.header_left_index {
  line-height: 51px;
  text-align: right;
  width: 40%;
  float: left;
}
.header_right_index {
  text-align: left;
  width: 60%;
  float: left;
}
.header_img {
  width: 51px;
  height: 51px;
  margin-right: 3px;
}
</style>
